module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01_pre"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("“The key to accomplishing your life’s work and living your wildest dreams is a secret hidden in plain view,” Addie Johnson writes. It’s all in a funny-looking, peculiar-sounding word: stick-to-it-iveness. Your grandma was right—anything worth doing is worth doing well, and doing until you do it the way you want to.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Stick-to-it-iveness")]), _vm._v(" is whimsical, inspirational, and motivational. As the saying goes, when the going gets tough, the tough get going. And this is just the book to get us going. A plethora of quotes, aphorisms, suggestions, and stories make this the perfect read for anyone who’s stuck in the mud or raring to go on a new venture. A phrase a day, and then another, sticking to it is where it’s at.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a96d8f5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01_pre.vue
// module id = 60
// module chunks = 0